import React, {Component} from 'react'
import Navigation from './components/navigation';
import Header from './components/header';
import Features from './components/features';
import DemoVideos from './components/demoVideos';
import HowItWorks from './components/howitworks';
import Services from './components/services';
import Testimonials from './components/testimonials';
import Pricing from './components/Pricing';
import Contact from './components/contact';
import JsonData from './data/data.json';
import ReactGA from 'react-ga';


ReactGA.initialize('UA-161757367-6');


export class MainPage extends Component {
	state = {
		landingPageData: {},
    ref: 'None'
	};

	getlandingPageData() {
		this.setState({landingPageData: JsonData})
	}

	componentDidMount() {
		this.getlandingPageData();
		const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');

    ReactGA.event({
      action: 'Page Visit',
			category: ref,
      label: ref + " visitor",
      value: 1
		});
    console.log(ref)
    this.setState({ref: ref || 'None'})
	}

	render() {
		return (
			<div>
				<Navigation/>
				<Header data={this.state.landingPageData.Header} source={this.state.ref}/>
				<Features data={this.state.landingPageData.Features}/>x
				<HowItWorks data={this.state.landingPageData.About} source={this.state.ref}/>
				<Services data={this.state.landingPageData.Services}/>
				<DemoVideos data={this.state.landingPageData.Services}/>
				<Testimonials data={this.state.landingPageData.Testimonials}/>
				<Pricing data={this.state.landingPageData.Prices} source={this.state.ref}/>
				<Contact data={this.state.landingPageData.Contact}/>
			</div>
		)
	}
}

export default MainPage;



// WEBPACK FOOTER //
// ./src/MainPage.jsx